import React, { useState, useEffect, useContext } from "react";
import CustomerType from "./customercard";
import Productcard from "./productcard";
import Truckcard from "./truckcard";
import Queuecard from "./queuecard";
import moment from "moment";
import FontAwesome from "react-fontawesome";
import { useHistory } from "react-router-dom";
//import querystring from 'query-string';
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { getregister } from "./../../services/wms";
import { saveRegister } from "./../../services/wms/register";
import ConfirmSubmit from "./../common/confirmSubmit";
import BranchContext from "./../context/branch";
import PopupAlert from "./../common/popupAlert";
import Input from "./../common/checkbox/input";
import {
  getdowood,
  getdowoodcontrolwood,
} from "../../services/wms/grabconcept";
//import ModelSelect from './../common/modalselect';

//import Select from './select'

const Register = (props) => {
  // let vForm =false;
  const history = useHistory();
  // console.log(props.Id)
  const [currentPrev, setcurrentPrev] = useState("");
  const [CompanyID, seCompanyID] = useState();
  const { currentBranch } = useContext(BranchContext);
  // const [Id, setId] = useState(props.match.params.id);
  const [Id, setId] = useState(props.Id);
  const [validation, setValidation] = useState(false);
  const [disabled, setdisabled] = useState(false);
  const [vForm1, setVForm1] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [nowDate, setNowDate] = useState(new Date());
  const [productTypeId, setProductTypeId] = useState(0);
  const [treeTypeId, settreeTypeId] = useState(0);
  const [lotid, setlot] = useState("");
  const [productId, setproductId] = useState(0);
  const [truckId, settruckId] = useState("");
  const [option1, setoption1] = useState("");
  const [option2, setoption2] = useState("");
  const [remark, setremark] = useState("");
  const [custypeId, setcustypeId] = useState("00");
  const [storeId, setstoreId] = useState(0);
  const [firstProvinceId, setfirstProvinceId] = useState(0);
  const [secProvinceId, setsecProvinceId] = useState(0);
  const [chkdowood, setchkdo] = useState();
  const [customerId, setcustomerId] = useState(0);
  const [customerIdpay, setcustomerIdpay] = useState(0);
  const [drivenId, setdrivenId] = useState("");
  const [doId, setdoId] = useState("");
  const [sourceProductId, setsourceProductId] = useState(0);
  const [comTruckID, setcomTruckID] = useState(0);
  const [axTruckID, setaxTruckID] = useState(0);
  const [comID, setcomID] = useState();
  const [ckdisable, setckdisable] = useState(false);
  const [aimId, setaimId] = useState("00");
  const [times, settimes] = useState("");
  const [askConfirm, setaskConfirm] = useState(false);
  const [message, setmessage] = useState("");
  const [drivenName, setdrivenName] = useState("");
  const [avgwood, setavgwood] = useState("0");
  const [drivenTel, setdrivenTel] = useState("");
  const [sourcedo, setsourcedo] = useState("");
  const [chkqueue, setchkqueue] = useState([]);
  const [loading, setLoading] = useState(false);
  const [onSave, setonSave] = useState(false);
  const [Controlledwood, setControlledwood] = useState("0");
  const [f1, setf1] = useState("");
  const [f2, setf2] = useState("");
  const [s1, sets1] = useState("");
  const [s2, sets2] = useState("");
  const [alldata, setalldata] = useState([]);

  const [messageErros, setmessageErros] = useState({
    askAlert: { enable: false, message: "" },
  });

  const [stateData, setstateData] = useState({
    data: {
      DO: "",
      identityId: "",
    },
    errors: { enable: false, message: "" },
  });
  //console.log("asdas",lotid)
  let schema1 = {
    DO: Joi.string().min(0).max(99999999).required().label("ใบนำส่ง"),
    identityId: Joi.string().min(0).max(99999999).required().label("ใบขับขี่"),
    drivenName: Joi.string().min(0).max(99999999).required().label("ชื่อคนขับ"),
    drivenTel: Joi.string()
      .min(0)
      .max(99999999)
      .required()
      .label("เบอร์โทรคนขับ"),
    f1: Joi.string().min(0).max(99999999).required().label("ทะเบียนรถ"),
    f2: Joi.string().min(0).max(99999999).required().label("ทะเบียนรถ"),
  };

  const Gotobackup = () => {
    setTimeout(history.goBack(), 1000);
  };

  const handleTextchange = () => {
    setckdisable(!ckdisable);
  };

  useEffect(() => {


    const loadRegister = async () => {
      try {
        if (currentBranch._id === "") return;
        if (!Id) return;
       
        if (Id === "new") {
          setalldata([]);
          setValidation(false);
          setcurrentPrev(currentBranch._id)
          return;
        }
        if(currentPrev === "" || currentBranch._id === currentPrev) {
          
        }else {
          toast.error("กรุณาระบุรายการใหม่");
          setonSave(false);
          setalldata([]);
          setValidation(false);
          setVForm1(false)
           const urlGoBack = "/registerlist/";
          setTimeout(history.replace(urlGoBack), 1000);

       //   history.push(urlGoBack)
           
          return;
        }

        setLoading(true);
        setcurrentPrev(currentBranch._id)
        const { data: result } = await getregister(Id, currentBranch._id);

        if (result) {

 
            
            result.filter((item) => item.AutoID === Id);
            setLoading(false);
            setalldata(result);
          
         
        } else {
          toast.error(result.message);
          setLoading(false);
        }
      } catch (ex) {
        toast.error(ex.message);
        setLoading(false);
      }
    };

    loadRegister();
  }, [Id, currentBranch,currentPrev]);
  useEffect(() => {
    const loadchkdo = async () => {
      try {
        if (currentBranch._id === "") return;
        if (custypeId === "00") return;
        if (doId == "") return;

        if (custypeId == "04" || custypeId == "15" || custypeId == "28") {
          const { data: result } = await getdowood(
            currentBranch._id,
            doId,
            custypeId
          );
          if (result == true) {
            setchkdo(result);
          } else {
            setchkdo(result);
          }
        } else if (custypeId == "21" || custypeId == "24") {
          const { data: result } = await getdowoodcontrolwood(
            currentBranch._id,
            doId
          );

          if (result.length > 0 && result[0].Result == "Fail") {
            setchkdo(result[0].Result);
            setControlledwood(result[0].Result);
          } else {
            setControlledwood(result[0].CWname);
            setchkdo(result[0].Result);
          }
        } else {
          setchkdo(false);
        }
      } catch (ex) {
        toast.error("eError", ex);
      }
    };
    loadchkdo();
  }, [Id, currentBranch, productId, doId, custypeId]);

  useEffect(() => {
    const getalldata = () => {
      //setId(props.match.params.id);
      setId(props.Id);
      if (vForm1) return;
      if (alldata && alldata.length === 1) {
        setdoId(alldata[0].DO);
        setcustypeId(alldata[0].customerType_id);
        setcustomerId(alldata[0].supplier_id);
        setdrivenId(alldata[0].driven_no);
        setdrivenName(alldata[0].driven_name);
        setdrivenTel(alldata[0].driver_tel);
        setProductTypeId(alldata[0].type_id);
        setproductId(alldata[0].ProductID);
        setaimId(alldata[0].receive_aim);
        settruckId(alldata[0].trucktype1);
        setfirstProvinceId(alldata[0].first_driven_prov);
        setoption1(alldata[0].option1);
        setoption2(alldata[0].option2);
        setsourceProductId(alldata[0].SourceProduct);
        setcomTruckID(alldata[0].TruckOwner);
        const queuedate = new Date(alldata[0].queue_date1);
        if (alldata[0].queue_date1) {
          setStartDate(queuedate);
        } else {
        }

        if (currentBranch._id == "501") {
          try {
            settreeTypeId(alldata[0].WoodType_ID);
          } catch {}
        }

        let editFullFirstDriven = alldata[0].first_driven_no;
        let editSecodeProvince = alldata[0].second_driven_prov;
        let editFullSecDriven = alldata[0].second_driven_no;

        setsecProvinceId(editSecodeProvince);

        if (editFullFirstDriven && !editFullFirstDriven == "") {
          var res = editFullFirstDriven.split("-");
          setf1(res[0]);
          setf2(res[1]);
        }
        if (!editFullSecDriven == "" && editFullSecDriven) {
          var res1 = editFullSecDriven.split("-");
          sets1(res1[0]);
          sets2(res1[1]);
        }

        if (alldata[0].store_id) {
          setstoreId(alldata[0].store_id);
        }

        if (alldata[0].queue_time) {
          settimes(alldata[0].queue_time);

          
        }
        if (alldata[0].WeightNo && !alldata[0].WeightNo == "") {
          setValidation(true);
          setdisabled(true);
        }

        setVForm1(true);
      } else {
        setdisabled(false);
        setValidation(false);
        if (Id === "new") {
          setVForm1(true);
          setdisabled(true);
        }
      }
    };
    getalldata();
  });
  // const redirect = () => {

  //   const urlGoBack = "/registerlist/";
  //   setTimeout(props.history.replace(urlGoBack), 1000);
  // }

  const doSubmit = async () => {
    setonSave(true)
     try {
      const doc = {
        _id: Id,
        customer_id: customerId,
        customer_type: custypeId,
        driven_id: drivenId,
        driven_name: drivenName,
        driven_tel: drivenTel,
        aim_no: aimId,
        delivery_no: doId.trim(),
        branch_id: currentBranch && currentBranch._id,
        store_id: storeId,
        truck_type: truckId,
        product_id: productId,
        product_type: productTypeId,
        trucktype: truckId,
        firstdriven_prov: firstProvinceId,
        seconddriven_prov: secProvinceId,
        option1,
        option2: option2,
        queue_date: moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        queue_time: times,
        firstdriven_no: f1 + "-" + f2,
        seconddriven_no: s1 + "-" + s2,
        remark,
        truckgroupid: comTruckID,
        axtruck: axTruckID,
        soureid: sourceProductId,
        Company: comID,
        appcode: "react",
        WoodType_ID: treeTypeId,
        productlot: lotid,
        isnormal: ckdisable,
        Controlledwood: Controlledwood,
        Company2: CompanyID,
        AVGWood: avgwood,
        Supplierpay_ID: customerIdpay,
        SourceDo: sourcedo,
      };

      const { data: result } = await saveRegister(doc);

      if (result.status === "success") {
        toast.success("บันทึกเสร็จเรียบร้อย");
        setonSave(false);
       // redirect();
         const urlGoBack = "/registerlist/";
        setTimeout(history.replace(urlGoBack), 1000);
      } else {
        toast.error(result.message);
        setonSave(false);
      }
    } catch (err) {
      toast.error("Error Try Catch");
      setonSave(false);
    }
  };
  const handleChageFProvinceId = (event) => {
    setfirstProvinceId(event);
  };
  const handleChageSProvinceId = (event) => {
    setsecProvinceId(event);
  };

  const handleChangIdentityId = (event) => {
    setdrivenId(event);
  };
  const handleChangTreetype = (event) => {
    settreeTypeId(event);
  };
  const handleChangtypefsc = (event) => {
    setControlledwood(event);
  };
  const handleChanglot = (event) => {
    setlot(event);
  };

  const onDrivenNameChange = (event) => {
    setdrivenName(event);
  };
  const onDrivenTelChange = (event) => {
    setdrivenTel(event);
  };
  const onsourcedoChange = (event) => {
    setsourcedo(event);
  };
  const onAimIdChange = (event) => {
    setaimId(event);
  };
  const handleChangdoId = (event) => {
    setdoId(event);
  };
  const onf1Change = (event) => {
    setf1(event);
  };
  const onf2Change = (event) => {
    setf2(event);
  };
  const ons1Change = (event) => {
    sets1(event);
  };
  const ons2Change = (event) => {
    sets2(event);
  };
  function handleChangeQueueDate(event) {
    event = setStartDate(event);
  }
  const handleOnsave = () => {
    const data = { ...stateData.data };
    const errorMessage = validate();
    if (errorMessage) {
      setstateData({ data, errors: { enable: false, message: errorMessage } });
    }
    if (custypeId === "00") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุประเภทลูกค้า\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (customerId == 0) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุชื่อลูกค้า\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (drivenId === "") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุเลขบัตรคนขับ\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (drivenName === "") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุชื่อคนขับ\nกรุณาระบุชื่อคนขับก่อนค่ะ",
        },
      });
      return;
    } else if (drivenTel == "") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุเบอร์ติดต่อคนขับ\nกรุณาระบุเบอร์ติดต่อก่อนค่ะ",
        },
      });
      return;
    } else if (doId == "") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุเลขที่เอกสาร\nกรุณาระบุเลขที่เอกสารก่อนค่ะ",
        },
      });
      return;
    } else if (productTypeId == 0 || productTypeId == null) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุประเภทสินค้า\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (productId == 0 || productId == null) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุสินค้า\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (aimId == "0" || aimId == "00") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุวัตถุประสงค์\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (truckId == "0" || !truckId) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุประเภทรถ\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (f1 == "") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุทะเบียนรถ\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (f2 == "") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุทะเบียนรถ\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (firstProvinceId === 0) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุจังหวัดทะเบียนรถ\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (
      CompanyID == 0 &&
      productTypeId == 5 &&
      currentBranch._id == "501"
    ) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุบริษัทที่ลงสินค้า\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (storeId == 0 && currentBranch._id !== "501") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุสถานที่ลง\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (
      currentBranch._id == "503" &&
      productId == "164" &&
      customerIdpay == "0"
    ) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุชื่อลูกค้า(ทำจ่าย)\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (
      productTypeId == "10" &&
      Controlledwood == "0" &&
      currentBranch._id == "501"
    ) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "กรุณาเลือกประเภทไม้ FSC\nก่อนค่ะ",
        },
      });
      return;
    } else if (comTruckID == 2 && axTruckID == "0") {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ท่านเลือกประเภทการจัดส่งไม่ถูกต้อง\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (
      currentBranch._id == "503" &&
      (sourceProductId == 0 || sourceProductId == undefined)
    ) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ท่านเลือกแหล่งทีมาไม่ถูกต้อง\nกรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else {
      const d1 = new Date(nowDate);
      const d2 = new Date(startDate);
      if (
        d1.getDate() > d2.getDate() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getyear() === d2.get.getyear()
      ) {
        setNowDate(Date);
        setmessageErros({
          askAlert: {
            enable: true,
            message: "ระบุวันที่ไม่ถูกต้อง\nกรุณาระบุวันที่ถูกต้องค่ะ",
          },
        });
        return;
      }
    }
    if (custypeId == "04" || custypeId == "15" || custypeId == "28") {
      if (chkdowood == false) {
        setmessageErros({
          askAlert: {
            enable: true,
            message: "เลขที่ Do ไม่ถูกต้องค่ะ",
          },
        });
        return;
      }
    } else if (custypeId == "21" || custypeId == "24") {
      if (chkdowood == false) {
        setmessageErros({
          askAlert: {
            enable: true,
            message:
              "เลขที่ Do ไม้เหมาแปลงแบบไร่/ไม้เหมาแปลงแบบตัน ไม่ถูกต้องค่ะ",
          },
        });
        return;
      }
    }

    setmessage("ท่านยืนยัน ที่ทำการบันทึกรายการใช่หรือไม่");
    setaskConfirm(true);
  };
  const handleChangeProductType = (event) => {
    setProductTypeId(event);
  };
  const handleChangeCompanyID = (event) => {
    seCompanyID(event);
  };
  const handleChangeTruck = (event) => {
    settruckId(event);
  };

  const handleChangeProduct = (event) => {
    setproductId(event);
  };
  const handleChangeavgwood = (event) => {
    setavgwood(event);
  };
  const handleChangeCustypeID = (event) => {
    setcustypeId(event);
  };
  const handleChangeStore = (event) => {
    setstoreId(event);
  };

  const handleChangeCustomer = (event) => {
    setcustomerId(event);
  };
  const handleChangeCustomerpay = (event) => {
    setcustomerIdpay(event);
  };
  const handleChangetimes = (event) => {
    settimes(event);
  };

  const handleConfirmSubmit = () => {
    doSubmit();
    setaskConfirm(false);
  };
  const handleCancleSubmit = () => {
    setaskConfirm(false);
  };
  const validateProperty = ({ name, value }) => {
    try {
      const obj = { [name]: value };
      const schema = { [name]: schema1[name] };
      const options = { abortEarly: true };
      const { error } = Joi.validate(obj, schema, options);
      return error ? error.details[0].message : null;
    } catch (err) {
      return err.message;
    }
  };

  const validate = () => {
    const allData = { DO: doId, identityId: drivenId, drivenName, drivenTel };
    const options = { abortEarly: false };
    const joiResult = Joi.validate(allData, schema1, options);
    const { error } = joiResult;

    if (!error) {
    } else {
      const errors = {};
      for (let item of error.details) {
        errors[item.path[0]] = item.message;
      }

      return errors;
    }
  };
  const handlechkqueueonline = (event) => {
    setchkqueue(event);
  };
  const handleProOption1 = (event) => {
    setoption1(event);
  };
  const handleProOption2 = (event) => {
    setoption2(event);
  };
  const handlePopupAlertClick = () => {
    setmessageErros({ askAlert: { enable: false, message: "" } });
  };

  const handleChangRemark = (event) => {
    setremark(event);
  };
  const handelAxTruckIdChange = (event) => {
    setaxTruckID(event);
  };
  const handleTruckGroupChange = (event) => {
    setcomTruckID(event);
  };
  const handleSourceIdChange = (event) => {
    setsourceProductId(event);
  };

  if (
    !currentBranch ||
    !vForm1 ||
    (currentBranch.currentBranch &&
      (currentBranch.currentBranch._id === "" ||
        currentBranch.currentBranch._id == null)) ||
    (alldata && alldata.length === 1 && Id === "new") ||
    !Id
  ) {
    return <></>;
  }
  if (currentBranch._id == "vms" || currentBranch._id == "0") {
    return <></>;
  }



  return (
    <>
      <div className="row">
        <div className="col-lg-6 p-0">
          <PopupAlert
            isOpen={messageErros.askAlert.enable}
            onOk={handlePopupAlertClick}
            message={messageErros.askAlert.message}
          />
          <ConfirmSubmit
            isOpen={askConfirm}
            onConfirm={handleConfirmSubmit}
            onCancel={handleCancleSubmit}
            message={message}
            button1="OK"
          />
          <CustomerType
            onLoad ={vForm1}
            id="CustTypeID"
            head="ข้อมูลลูกค้า"
            typename="ประเภทลูกค้า"
            name="ชื่อลูกค้า"
            drivenno="เลขบัตร(คนขับ)"
            drivenname="ชื่อคนขับ"
            registerError={stateData.errors.message}
            handleChangeCustype={handleChangeCustypeID}
            paramsMatchId={Id}
            onChange={handleChangIdentityId}
            allEditData={alldata}
            onDrivenNameChange={onDrivenNameChange}
            onDrivenTelChange={onDrivenTelChange}
            handleTruckGroupChange={handleTruckGroupChange}
            handelAxTruckIdChange={handelAxTruckIdChange}
            handleChangeCustomer={handleChangeCustomer}
            handleChangeCustomerpay={handleChangeCustomerpay}
            productId={productId}
            onsourcedoChange={onsourcedoChange}
          />
        </div>
        <div className="col-lg-6 p-0">
          <Productcard
           onLoad ={vForm1}
            head="ข้อมูลสินค้า"
            id="productid"
            typename="ประเภทสินค้า"
            proname="ชื่อสินค้า"
            DO="ใบนำส่ง"
            labelProOption1="น้ำหนักต้นทาง(กก.)"
            labelProOption2="PO ต้นทาง"
            aimname="วัตถุประสงค์"
            registerError={stateData.errors.message}
            handelComIdChange={handleChangeCompanyID}
            handleChangeProductType={handleChangeProductType}
            handleProOption1={handleProOption1}
            handleProOption2={handleProOption2}
            handleChangeProduct={handleChangeProduct}
            handleChangeAim={onAimIdChange}
            onChange={handleChangdoId}
            handleChangeTreetype={handleChangTreetype}
            allEditData={alldata}
            paramsMatchId={Id}
            handleChangelot={handleChanglot}
            chkqueuetype={handlechkqueueonline}
            handleChangeavgwood={handleChangeavgwood}
            handleChangetypefsc={handleChangtypefsc}
          />
        </div>
        <div className="col-lg-6 p-0 ">
          <Truckcard
           onLoad ={vForm1}

            id="truckid"
            head="ข้อมูลรถ"
            typename="ประเภทรถ"
            firstdriven="ทะเบียนรถ"
            handleChageFProvinceId={handleChageFProvinceId}
            secdriven="ทะเบียนหาง"
            handleChageSProvinceId={handleChageSProvinceId}
            paramsMatchId={Id}
            allEditData={alldata}
            handleChangeTruck={handleChangeTruck}
            onf1Change={onf1Change}
            onf2Change={onf2Change}
            ons1Change={ons1Change}
            ons2Change={ons2Change}
            handleChangeTreetype={handleChangTreetype}
          />
        </div>

        <div className="col-lg-6 p-0">
          <Queuecard
           onLoad ={vForm1}
            id="id1"
            head="ข้อมูลการลงสินค้า"
            typename="วันที่ลงสินค้า"
            onChange={handleChangeQueueDate}
            allEditData={alldata}
            selected={startDate}
            onchangremark={handleChangRemark}
            handleSourceIdChange={handleSourceIdChange}
            handleChangequeuetime={handleChangetimes}
            handleChangeProductType01={handleChangeProductType}
            paramsMatchId={Id}
            proid={productId}
            Typeid={productTypeId}
            customerid={customerId}
            name="เวลา"
            identity="ทะเบียนหาง"
            store="สถานที่ลง"
            handleChangeStore={handleChangeStore}
            handleChangefirstdriven={f1 + "-" + f2}
            handleChangefirstdrivenprov={firstProvinceId}
          />

          <div className="d-flex justify-content-center col-lg-6 ms-4">
            <Input
              name="disable"
              className="form-check form-check-inline "
              value={ckdisable}
              label="ยกเลิกใช้งาน"
              type="checkbox"
              disable={disabled}
              onChange={handleTextchange}
              checked={ckdisable}
              error=""
            />
          </div>
        </div>
      </div>
      <div className="row d-flex justify-content-center ms-1 me-1">
        <div className="col-lg-6 col-md-6 p-1">
          <div className="card">
            <button
              type="button"
              disabled={loading}
              className="btn btn-warning btn-lg"
              onClick={Gotobackup}
            >
              <span className="me-2">
                <FontAwesome name="arrow-left" />
              </span>
              <span>กลับ</span>
            </button>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 p-1 ">
          <div className="card">
            <button
              type="button"
              disabled={validation || loading || onSave}
              className="btn btn-primary btn-lg"
              onClick={handleOnsave}
            >
              <span className="me-2">
                <FontAwesome name="save" />
              </span>
              Save{" "}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
